export default __webpack_public_path__ + "static/media/butterfly1.80efb2ce.png";